// utils/axiosInstance.ts
import axios from 'axios';

const basePath = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

const Axios = axios.create({
  baseURL: basePath,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default Axios;
